// extracted by mini-css-extract-plugin
module.exports = {"globalLoding":"Loading_global-loding__2wwAv"};